import { useEffect, useRef, useState } from "react";
import { useDebounce } from "hooks/useDebounce";
// import { fetchCollectionSearchApi } from "hooks/collection";

interface Collection {
  id: string;
  name?: string | null;
  type?: string | null;
  thumbnail?: string;
  cardImage1?: string;
  redirection_to?: string | null;
  redirection_id?: string | null;
  redirectionId?: string | null;
}

interface Props {
  collections: Collection[]
  value?: Collection | null;
  onSelect: (category: Collection) => void;
  placeholder?: string;
  selectedItems?: Collection[];
}

export default function SearchableCollectionDropdown({
  value,
  collections,
  onSelect,
  placeholder = "Search collection & show...",
  selectedItems,

}: Props) {
  const [query, setQuery] = useState(value?.name || "");
  const [options, setOptions] = useState<Collection[]>([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const isUserTypingRef = useRef(false);

  const debouncedQuery = useDebounce(query, 400);
  const dropdownRef = useRef<HTMLDivElement>(null);
  
  // Update query when value prop changes (for initialData/prefill)
  useEffect(() => {
    if (value?.name && !isUserTypingRef.current) {
      setQuery(value.name);
    } else if (!value && !isUserTypingRef.current) {
      setQuery("");
    }
  }, [value?.name, value?.id]);

  /* 🔍 Fetch categories */
  // useEffect(() => {
  //   if (!debouncedQuery.trim()) {
  //     setOptions([]);
  //     return;
  //   }

  //   const load = async () => {
  //     try {
  //       setLoading(true);

  //      const res = collections
  //       .filter((c:any) =>
  //         c?.collection?.name
  //           .toLowerCase()
  //           .includes(debouncedQuery.toLowerCase())
  //       )
  //       .map((c:any) => c.collection)
  //       console.log("res1234",res)
  //       setOptions(res);
  //     } catch (err) {
  //       console.error(err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   load();
  // }, [debouncedQuery]);

  /* 🔍 Fetch categories Added for default listing */
  useEffect(() => {
    try {
      setLoading(true);

      let res: Collection[] = [];

      if (!debouncedQuery.trim()) {
        // Show ALL collections
        // res = collections.map((c: any) => c.collection);
        res = collections.map((c: any) => // Added for both Collections and Shows
          c.type === 'collection' ? c.collection : c.show
        );
      } else {
        // Filter collections
        res = collections
          .filter((c: any) =>
            c?.collection?.name
              ?.toLowerCase()
              .includes(debouncedQuery.toLowerCase())
          )
          .map((c: any) => c.collection);
      }

      setOptions(res);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [debouncedQuery, collections]);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (!dropdownRef.current?.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSelect = (item: Collection) => {
    isUserTypingRef.current = false;
    onSelect(item);
    // setQuery(item.name || '');
    setQuery('');
    setOpen(false);
  };

  return (
    <div ref={dropdownRef} className="relative w-full">
      <input
        value={query}
        placeholder={placeholder}
        onChange={(e) => {
          isUserTypingRef.current = true;
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => {
          setOpen(true);
          // If value exists, allow user to search by clearing query
          if (value?.name && query === value.name) {
            isUserTypingRef.current = false;
          }
        }}
        onBlur={() => {
          // Reset typing flag after a delay to allow value updates
          setTimeout(() => {
            isUserTypingRef.current = false;
          }, 200);
        }}
        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"
      />

      {open && (
        <div className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800">
          {loading && (
            <div className="px-3 py-2 text-sm text-gray-500">
              Searching...
            </div>
          )}

          {!loading && options.length === 0 && (
            <div className="px-3 py-2 text-sm text-gray-500">
              No results found
            </div>
          )}

          {options.map((item) => {

            const isSelected = selectedItems?.some((selectedItem) => selectedItem?.redirectionId === item.id);
            // return (
            //   <div
            //     key={item.id}
            //     onClick={() => {
            //       if (!isSelected) handleSelect(item);
            //     }}
            //     className={`px-3 py-2 text-sm ${
            //       isSelected
            //         ? "cursor-not-allowed text-gray-400 bg-gray-50"
            //         : "cursor-pointer hover:bg-blue-50"
            //     }`}
            //   >
            //     {item.name}
            //     {isSelected}
            //   </div>
            // );
            return (
              <div
                key={item.id}
                onClick={() => {
                  if (!isSelected) handleSelect(item)
                }}
                className={`px-3 py-2 text-sm flex justify-between items-center
                                   ${isSelected
                    ? 'cursor-not-allowed text-gray-400 bg-gray-50'
                    : 'cursor-pointer hover:bg-blue-50'
                  }`}>
                <div>
                  <div>{item.name}</div>
                  <div
                    className={`inline-block mt-1 px-2 py-0.5 text-xs font-medium rounded-full
    ${item.type === 'collection' && 'bg-blue-100 text-blue-700'}
    ${item.type === 'show' && 'bg-purple-100 text-purple-700'}`}
                  >
                    {item.type}
                  </div>
                </div>

                {isSelected && (
                  <span className="text-xs font-medium text-green-600">
                    Added
                  </span>
                )}
              </div>
            )

          })}

        </div>
      )}
    </div>
  );
}
